<template>
  <BaseDialog
    v-model="internalValue"
    @input="$emit('input', $event)"
    :title="'Eliminar Esdeveniment'"
    :subtitle="subtitle"
    :cancelText="'Cancel·la'"
    :confirmText="'Desa'"
    :loading="loading"
    :maxWidth="'600px'"
    :backgroundColor="'#f9efd5'"
    :confirmColor="'#ff0000'"
    role="dialog"
    aria-modal="true"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
  </BaseDialog>
</template>

<script>
import BaseDialog from './BaseDialog.vue'
import i18n from '@/i18n'

export default {
  name: 'DeleteEventDialog',
  components: { BaseDialog },
  props: {
    value: { type: Boolean, required: true },
    event: Object,
    team: Object,
    loading: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    subtitle () {
      const action = this.event && this.event.type
        ? this.event.type
        : this.event.type
      const actionTranslated = i18n.t(`miccamps.match_actions.${action}`)
      const teamName = this.team && this.team.name ? this.team.name : ''
      return `Estàs segur que vols eliminar el ${actionTranslated} del equip ${teamName}?`
    }
  },
  methods: {
    onCancel () {
      if (this.loading) return
      this.$emit('input', false) // close the dialog
    },
    onConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>
